import React, { useState, useRef } from 'react';
import { MapPin, DollarSign, ChevronLeft, ChevronRight, Download } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function JobVacancies() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const {
    t
  } = useLanguage();
  const jobs = t('jobs.items');
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const cardWidth = scrollContainerRef.current.offsetWidth / 3;
      const scrollAmount = direction === 'left' ? -cardWidth : cardWidth;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
      if (direction === 'left' && currentIndex > 0) {
        setCurrentIndex(currentIndex - 1);
      } else if (direction === 'right' && currentIndex < jobs.length - 3) {
        setCurrentIndex(currentIndex + 1);
      }
    }
  };
  return <section className="w-full py-16 px-6 md:px-12 bg-[var(--color-bg)]" data-id="element-244">
      <div className="max-w-7xl mx-auto" data-id="element-245">
        {/* Header */}
        <div className="flex items-center justify-between mb-8" data-id="element-246">
          <div data-id="element-247">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 border border-gray-200 rounded-full bg-white mb-4" data-id="element-248">
              <span className="text-sm font-medium text-[var(--color-text-dark)]" data-id="element-249">
                {t('jobs.pill')}
              </span>
            </div>
            <h2 className="sr-only" data-id="element-250">{t('jobs.pill')}</h2>
          </div>

          {/* Navigation arrows */}
          <div className="flex gap-2" data-id="element-251">
            <button onClick={() => scroll('left')} disabled={currentIndex === 0} className="w-10 h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-252">
              <ChevronLeft className="w-5 h-5" data-id="element-253" />
            </button>
            <button onClick={() => scroll('right')} disabled={currentIndex >= jobs.length - 3} className="w-10 h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-254">
              <ChevronRight className="w-5 h-5" data-id="element-255" />
            </button>
          </div>
        </div>

        {/* Horizontal Scrolling Container */}
        <div ref={scrollContainerRef} className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-256">
          {jobs.map((job: any, index: number) => <div key={index} className="flex-shrink-0 w-full md:w-[calc(33.333%-16px)] bg-white rounded-xl p-6 border border-gray-100 snap-start" data-id="element-257">
              <h3 className="text-lg font-semibold text-[var(--color-text-dark)] mb-1" data-id="element-258">
                {job.title}
              </h3>
              <p className="text-sm text-[var(--color-text-light)] mb-4" data-id="element-259">
                {job.type}
              </p>

              <div className="flex items-center gap-4 mb-4" data-id="element-260">
                {job.location && <div className="flex items-center gap-1.5 text-sm text-[var(--color-text-light)]" data-id="element-261">
                    <MapPin className="w-4 h-4" data-id="element-262" />
                    <span data-id="element-263">{job.location}</span>
                  </div>}
                {job.salary && <div className="flex items-center gap-1.5 text-sm text-[var(--color-text-light)]" data-id="element-264">
                    <DollarSign className="w-4 h-4" data-id="element-265" />
                    <span data-id="element-266">{job.salary}</span>
                  </div>}
              </div>

              <p className="text-sm text-[var(--color-text-light)] mb-6 line-clamp-4" data-id="element-267">
                {job.desc}
              </p>

              <button className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity" data-id="element-268">
                {t('jobs.sendResume')}
                <Download className="w-4 h-4" data-id="element-269" />
              </button>
            </div>)}
        </div>

        {/* Progress indicator */}
        <div className="flex justify-center mt-6 gap-2" data-id="element-270">
          {Array.from({
          length: Math.ceil(jobs.length / 3)
        }).map((_, index) => <button key={index} onClick={() => {
          setCurrentIndex(index * 3);
          if (scrollContainerRef.current) {
            const cardWidth = scrollContainerRef.current.offsetWidth / 3;
            scrollContainerRef.current.scrollTo({
              left: index * cardWidth * 3,
              behavior: 'smooth'
            });
          }
        }} className={`w-2 h-2 rounded-full transition-colors ${Math.floor(currentIndex / 3) === index ? 'bg-[var(--color-tan)]' : 'bg-gray-300'}`} data-id="element-271" />)}
        </div>
      </div>
    </section>;
}